import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropdownItem, SplitButton } from '@optimus-web/core';
import { TwoStepProcessPaymentDialog } from '../../../TwoStepProcessPaymentDialog';

export const BulkProcessPayment = () => {
    const [{ active: isModalOpen, onClose: handleModalClose }, toggleModalOpen] = useDialog();
    const [{ active: isExternalModalOpen, onClose: handleExternalModalClose }, toggleExternalModalOpen] = useDialog();

    return (
        <>
            <SplitButton
                label={<LocalizedText textKey={TextKey.PaymentMethodActionProcessPayment} />}
                variant="primary"
                onClick={toggleModalOpen}
                data-test-id="default-bulk-payments"
            >
                <DropdownItem
                    label={<LocalizedText textKey={TextKey.ProcessPaymentDialogSplitButtonListItemPrimaryText} />}
                    onClick={toggleExternalModalOpen}
                    data-test-id="external-bulk-payments"
                />
            </SplitButton>
            {isModalOpen && <TwoStepProcessPaymentDialog dialogType="default" onClose={handleModalClose} />}
            {isExternalModalOpen && (
                <TwoStepProcessPaymentDialog dialogType="external" onClose={handleExternalModalClose} />
            )}
        </>
    );
};
